<template>
    <div v-if="session">
        <top-navbar padding="6" :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="row">
                <div class="col-md-12">
                    <session-header :session="session" :status-data="statusData" :status-colors="statusColors"></session-header>
                    <session-steps :session="session"></session-steps>
                    <session-configuration :session="session" :simulations="simulations" @reload-session="loadSession"></session-configuration>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SessionFeatures from './sessions/SessionFeatures'
    import SessionHeader from './sessions/SessionHeader';
    import SessionSteps from './sessions/SessionSteps';
    import SessionConfiguration from './sessions/SessionConfiguration';

    export default {

        components: {
            SessionHeader, SessionSteps, SessionConfiguration
        },

        data() {
            return {
                session: null,
                simulations: null,
                statusData: [],
                statusColors: {},
                features: new SessionFeatures(this.$router, this.$auth),
                reloaderId: null,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.sessions'),
                        route: '/socrates/ui/dashboard/sessions'
                    },
                    {
                        name: this.session.cohort.name + ' / ' + this.session.degree.name,
                        route: '/socrates/ui/dashboard/sessions/registrations/' + this.session.registration_id
                    },
                    {
                        name: this.session.learner.name,
                    },
                ]
            },

            canStartReloader() {
                return !this.session.sync
            },
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/socrates/api/front/dashboard/page/sessions/' + to.params.id + '/configuration', { params: {
                include: ['simulations', 'status_data', 'status_colors', 'rights']
            }})
            .then(resp => {
                next(vm => {
                    vm.session = resp.data.data
                    vm.simulations = resp.data.included.simulations
                    vm.statusData = resp.data.included.status_data
                    vm.statusColors = resp.data.included.status_colors
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                    vm.initReloader()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                } else if (err.response.status == 444) {
                    // This may happen if the connection fails with an online session.
                    next({ name: 'home' });
                }
            });
        },

        beforeDestroy() {
            this.clearReloader()
        },

        methods: {

            clearReloader() {
                if (this.reloaderId) {
                    clearInterval(this.reloaderId)
                }
            },
        
            initReloader() {
                if (!this.reloaderId && this.canStartReloader) {
                    this.reloaderId = setInterval(() => { this.loadSession() }, 3000)
                }
                if (this.reloaderId && !this.canStartReloader) {
                    clearInterval(this.reloaderId)
                    this.reloaderId = null
                }
            },

            loadSession() {
                axios.get('/socrates/api/front/dashboard/page/sessions/' + this.session.id + '/configuration')
                .then(resp => {

                    if (this.sessionChanged(resp.data.data)) {
                        // Important to limit the watcher actions in the child component.
                        this.session = resp.data.data
                    }

                    if (!this.features.canEdit(this.session)) {
                        return this.features.openSessions(this.session)
                    }

                    if (this.features.sessionIsClosed(this.session)) {
                        return this.features.openSummary(this.session)
                    }

                    this.initReloader()
                })
                .catch(err => {
                    if (err.response.status == 500) {
                        // Do nothing. This may happen occasionally.
                    } else if (err.response.status == 444) {
                        // This may happen if the connection fails with an online session.
                        this.$router.push({ name: 'home'})
                    } else {
                        this.$auth.handleErrorVm(err, this)
                    }
                })        
            },

            sessionChanged(newSession) {
                // Only changes which have an impact on the configuration process.
                return newSession.status != this.session.status
                    || newSession.tester1_id != this.session.tester1_id
                    || newSession.tester2_id != this.session.tester2_id
                    || newSession.two_testers != this.session.two_testers
                    || (newSession.sync && !this.session.sync)
                    || (!newSession.sync && this.session.sync)
            }
        }
    }
</script>
